/**
 * Application List
 */
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

const componentName = 'animated-header';

export class AnimatedHeader extends Component {
    /**
     * Component Setup
     */

    // Elements
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        content: this.element.querySelector(`.${componentName}__content`),
        lead: this.element.querySelector(`.${componentName}__lead-text`),
        title: this.element.querySelector(`.${componentName}__title-text`),
        subtitle: this.element.querySelector(`.${componentName}__subtitle-text`),
    };

    // State
    state = {
        contentMargin: 0,
        tween: null,
        tl: null
    };

    initDom = () => {
        gsap.registerPlugin(ScrollTrigger);
        this.state.tl = gsap.timeline({
            scrollTrigger: {
                trigger: `.${componentName}__content`,
                toggleActions: 'restart none none none',
                start: 'top bottom',
                end: 'top center',
                scrub: 0.6
            }
        });

        // Resize animation
        this.state.contentMargin = (this.elements.content.offsetHeight / 8);
        this.state.tween = gsap.fromTo(this.elements.content, {
            scale: 1.25,
            marginTop: this.state.contentMargin,
            marginBottom: this.state.contentMargin
        }, {
            scale: 1,
            marginTop: 0,
            marginBottom: 0,
            ease: 'power2.out'
        });
        this.state.tl.add(this.state.tween);

        window.addEventListener('resize', this.resizeListener);
    };

    resizeAnimation = () => {
        this.state.tl.remove(this.state.tween);
        this.state.tween = gsap.fromTo(this.elements.content, {
            scale: 1.25,
            marginTop: this.state.contentMargin,
            marginBottom: this.state.contentMargin
        }, {
            scale: 1,
            marginTop: 0,
            marginBottom: 0,
            ease: 'power2.out'
        });
        this.state.tl.add(this.state.tween);
    };

    // Resize listener to update contentMargin and trigger animation
    resizeListener = () => {
        const newContentMargin = (this.elements.content.offsetHeight / 8);
        if (newContentMargin !== this.state.contentMargin) {
            this.state.contentMargin = newContentMargin;
            this.resizeAnimation();
        }
    };

    /**
     * Initialize Component
     */
    init() {
        // Fire Init Funcs
        if(!isEditModeFooter() && (this.elements.container.getAttribute('data-is-animated') === 'true')) {
            this.initDom();
        }
    }
}

registerComponent(`.${componentName}`, AnimatedHeader);
